export enum MerchantType {
    Bhn = 'BHN',
    SweePay = 'SWEEPAY',
    SweePayTopUp = 'SWEEPAYTOPUP',
    ePAY = 'EPAY',
    OFFERZ = 'OFFERZ',
}
